export var AutodiscoveryJobSource;
(function (AutodiscoveryJobSource) {
    AutodiscoveryJobSource["Manual"] = "MANUAL";
    AutodiscoveryJobSource["CampaignClone"] = "CAMPAIGN_CLONE";
    AutodiscoveryJobSource["System"] = "SYSTEM";
})(AutodiscoveryJobSource || (AutodiscoveryJobSource = {}));
export var AutodiscoveryJobStatus;
(function (AutodiscoveryJobStatus) {
    AutodiscoveryJobStatus["Queued"] = "QUEUED";
    AutodiscoveryJobStatus["Submitting"] = "SUBMITTING";
    AutodiscoveryJobStatus["Processing"] = "PROCESSING";
    AutodiscoveryJobStatus["WaitingCallback"] = "WAITING_CALLBACK";
    AutodiscoveryJobStatus["Completing"] = "COMPLETING";
    AutodiscoveryJobStatus["Complete"] = "COMPLETE";
    AutodiscoveryJobStatus["Failed"] = "FAILED";
    AutodiscoveryJobStatus["TimedOut"] = "TIMED_OUT";
})(AutodiscoveryJobStatus || (AutodiscoveryJobStatus = {}));
export var AutodiscoveryJobErrorCode;
(function (AutodiscoveryJobErrorCode) {
    AutodiscoveryJobErrorCode["MissingAiJobId"] = "MISSING_AI_JOB_ID";
    AutodiscoveryJobErrorCode["ManualRecovery"] = "MANUAL_RECOVERY";
    AutodiscoveryJobErrorCode["SubmissionUnknown"] = "SUBMISSION_UNKNOWN";
})(AutodiscoveryJobErrorCode || (AutodiscoveryJobErrorCode = {}));
const activeStatuses = new Set([
    AutodiscoveryJobStatus.Queued,
    AutodiscoveryJobStatus.Submitting,
    AutodiscoveryJobStatus.Processing,
    AutodiscoveryJobStatus.WaitingCallback,
    AutodiscoveryJobStatus.Completing,
]);
const errorStatuses = new Set([
    AutodiscoveryJobStatus.Failed,
    AutodiscoveryJobStatus.TimedOut,
]);
export const isAutodiscoveryJobActive = (status) => activeStatuses.has(status);
export const isAutodiscoveryJobError = (status) => errorStatuses.has(status);
//# sourceMappingURL=AutodiscoveryJob.js.map